import SmoothScroll from "smooth-scroll"
new SmoothScroll(".js-smooth", {
	speed: 300,
})
